import React, { memo } from 'react'
import { FormattedDateTime } from 'transfix-ui/components/FormattedDateTime'
import { Box, Link } from 'transfix-ui/core'
import { CarrierListItemTag } from 'apps/marketplace/pages/shipment-details/components/CarrierCallList/CarrierListItemTag'
import { TableRow, TableCell } from 'transfix-ui'
import { capitalize } from 'utils/capitalize'
import { formatCurrency } from 'utils/formatCurrency'
import { DISPLAY } from 'constants/display'
import { IShipmentMatchFragment } from './graphql/ShipmentMatchFragment'

interface IMatchingShipmentRowProps {
  laneCarrierMatch: IShipmentMatchFragment
}
export const MatchingShipmentRow = memo<IMatchingShipmentRowProps>(({ laneCarrierMatch }) => {
  const { shipment, strongestMatch } = laneCarrierMatch || {}
  const {
    equipment,
    firstPickup,
    id: shipmentId,
    lastDelivery,
    listRate: rate,
    shipperApplication,
  } = shipment || {}
  const { name: equipmentName } = equipment || {}
  const { appointment: puAppt, city: pCity, stateCode: pState } = firstPickup || {}
  const { startAt: pickupDate, timezone: pickupTimeZone } = puAppt
  const { appointment: dAppt, city: dCity, stateCode: dState } = lastDelivery || {}
  const { startAt: deliveryDate, timezone: deliveryTimeZone } = dAppt
  const { id: shipperId, name: shipperName } = shipperApplication || {}
  const listRate = formatCurrency(rate, undefined, true) || DISPLAY.empty
  const pickupCity = firstPickup ? `${capitalize(pCity!)}, ${pState}` : DISPLAY.empty
  const deliveryCity = lastDelivery ? `${capitalize(dCity!)}, ${dState}` : DISPLAY.empty

  return (
    <TableRow>
      <TableCell>
        <Box display='inline-flex'>
          <Box mr={1}>
            <Link
              href={`${__ROOT__}/shipment-details/${shipmentId}`}
              target='_blank'
              rel='noopener noreferrer'>
              {shipmentId}
            </Link>
          </Box>

          {strongestMatch && (
            <Box>
              <CarrierListItemTag matchType={strongestMatch} />
            </Box>
          )}
        </Box>
      </TableCell>
      <TableCell>{equipmentName}</TableCell>
      <TableCell>
        {pickupDate! && (
          <FormattedDateTime
            displayTimezone={pickupTimeZone}
            datetime={pickupDate!}
            format='dateAndYearFullDateAlways'
            abbreviated
          />
        )}
      </TableCell>
      <TableCell>{pickupCity}</TableCell>
      <TableCell>
        {deliveryDate! && (
          <FormattedDateTime
            displayTimezone={deliveryTimeZone}
            datetime={deliveryDate!}
            format='dateAndYearFullDateAlways'
            abbreviated
          />
        )}
      </TableCell>
      <TableCell>{deliveryCity}</TableCell>
      <TableCell>{listRate}</TableCell>
      <TableCell>
        <Link href={`${__ROOT__}/shippers/${shipperId}`} target='_blank' rel='noopener noreferrer'>
          {shipperName}
        </Link>
      </TableCell>
    </TableRow>
  )
})
